//#region imports
import customAxios from '../../utils/customAxios';
import React, { useState, useEffect, createRef } from 'react';

import { DataGridPro, GridRow } from '@mui/x-data-grid-pro';

import { Tooltip } from '@mui/material';

import { Stack } from '@mui/system';

import { library } from '@fortawesome/fontawesome-svg-core';
import {
  fas,
  faCalendarPlus,
  faBan,
  faChalkboardUser,
  faHandshakeAngle,
  faStreetView,
  faScrewdriverWrench,
  faFlagCheckered,
  faSquarePlus,
  faPersonCirclePlus,
  faXmark,
  faThumbsUp,
  faSkullCrossbones,
  faPersonWalkingArrowRight,
  faCheckDouble,
} from '@fortawesome/free-solid-svg-icons';

import { DeleteOutlineOutlined as DeleteIcon } from '@mui/icons-material';

import DriveFileMoveOutlinedIcon from '@mui/icons-material/DriveFileMoveOutlined';

import { toast } from 'react-toastify';
import { useTranslationHook } from '../../hooks/UseTranslationHook';
import { useTranslation } from 'react-i18next';
import i18next from 'i18next';
import ModalQuestion from '../Modal/Create/ModalQuestion';
import ModalMessage from '../Modal/Create/ModalMessage';
import ModalQDelete from '../Modal/Delete/ModalQDelete';
import ModalQMultDelete from '../Modal/Delete/Multiple/ModalQMultDelete';
import { GlobalVariables } from '../../globalVar';
import ModalTitle from '../Modal/Create/ModalTitle';
import MoveToSectionMenu from '../Questionnaire/MoveToSectionMenu';
import { getToast } from '../../utils/toastConfig';
import { useTableLocale } from '../../hooks/useTableLocale';

library.add(
  fas,
  faCalendarPlus,
  faBan,
  faChalkboardUser,
  faHandshakeAngle,
  faStreetView,
  faScrewdriverWrench,
  faFlagCheckered,
  faSquarePlus,
  faPersonCirclePlus,
  faXmark,
  faThumbsUp,
  faSkullCrossbones,
  faPersonWalkingArrowRight,
  faCheckDouble,
);

//#endregion

export const ConfigQuestions = ({
  setIsButtonDisabled,
  rowSelectionModel,
  setRowSelectionModel,
  selectedSection,
  selectedQuestionnaire,
  modalQuestionShow,
  modalMessageShow,
  modalSectionShow,
  modalQMultipleDeleteShow,
  setModalQuestionShow,
  setModalMessageShow,
  setModalSectionShow,
  setModalQMultipleDeleteShow,
  getDirectoryData,
}) => {
  // hooks configuration
  const [configQData, setConfigQData] = useState([]);

  const [modalQDeleteShow, setModalQDeleteShow] = useState(false);

  const [isLoading, setIsLoading] = useState(true);

  const { t } = useTranslation();

  // State to handle the selectedQuestion
  const [selectedQuestion, setSelectedQuestion] = useState(null);

  const anchorSecMenuRefs = configQData.reduce((acc, row) => {
    acc[row.id] = createRef();
    return acc;
  }, {});

  const [openSecMenu, setOpenSecMenu] = useState(false);

  const {
    questionsQuestionString,
    questionsQTypeString,
    questionsRTypeString,
    noQuestionsString,
    qQuestionsAddQString,
    qQuestionsAddMString,
    qQuestionsAddLoopString,
    qQuestionsAddIfString,
    qQuestionsAddTitleString,
    qQuestionsAddTableString,
    detailString,
    deleteString,
    moveString,
    qQuestionsMultDeleteString,
  } = useTranslationHook();

  const locale = useTableLocale();

  useEffect(() => {
    const updateQData = () => {
      setConfigQData((prevData) => {
        return prevData.map((question) => ({
          ...question,
        }));
      });
    };
    i18next.on('languageChanged', updateQData);

    return () => {
      i18next.off('languageChanged', updateQData);
    };
  }, [t]);

  /**
   * Function to obtain questions from selected section of a questionnaire
   * @returns {any} Data from all questions to populate the table
   */
  const getData = async (section) => {
    if (section != null) {
      const endpoint = `${GlobalVariables.getURL()}questionsFromSection/${section}`;
      setIsLoading(true);

      try {
        const response = await customAxios.get(endpoint, {
          headers: {
            Authorization: 'bearer ' + localStorage.getItem('token'),
          },
        });
        const configQData = response.data.map((question, index) => {
          return {
            ...question,
          };
        });
        setConfigQData(configQData);
        return configQData;
      } catch (error) {
        console.log(error);
      } finally {
        setIsLoading(false);
      }
    }
  };

  useEffect(() => {
    if (selectedSection !== null) {
      getData(selectedSection);
    }
  }, [selectedSection]);

  useEffect(() => {
    // Nothing to do in this useEffect
  }, [isLoading]);

  /**
   * Function to close the MoveToSectionMenu component
   */
  function handleSecMenuClose() {
    setSelectedQuestion(null);
    setOpenSecMenu(false);
  }

  const actionColumn = [
    {
      field: 'action',
      headerName: detailString,
      width: 100,
      renderCell: (params) => {
        function handleDelete(questionInfo) {
          var questionId = questionInfo.id;
          var questionText = questionInfo.name;
          var questionType = questionInfo.question_type;
          var questionRType = questionInfo.answer_type;

          localStorage.setItem('questionIdForDelete', questionId);
          localStorage.setItem('questionTextToDelete', questionText);
          localStorage.setItem('questionTypeToDelete', questionType);
          localStorage.setItem('questionRTypeToDelete', questionRType);

          setModalQDeleteShow(true);
        }

        /**
         * Function to open the MoveToSectionMenu component
         */
        function handleOpenSecMenu(questionId) {
          setSelectedQuestion(questionId);
          setOpenSecMenu(true);
        }

        return (
          <div className='cellAction'>
            <Tooltip title={deleteString} arrow>
              <button
                style={{
                  background: 'none',
                  border: 'none',
                  padding: 0,
                  marginTop: '5px',
                }}
                onClick={() => handleDelete(params.row)}
              >
                <DeleteIcon className='detail-icons' id='delete-icon' />
              </button>
            </Tooltip>
            <Tooltip title={moveString} arrow>
              <button
                style={{
                  background: 'none',
                  border: 'none',
                  padding: 0,
                  marginTop: '5px',
                }}
                onClick={() => handleOpenSecMenu(params.row.id)}
                ref={anchorSecMenuRefs[params.row.id]}
              >
                <DriveFileMoveOutlinedIcon className='detail-icons' />
              </button>
            </Tooltip>
          </div>
        );
      },
    },
  ];

  // Columns
  const configQColumns = [
    {
      field: 'id',
      headerName: 'ID',
      width: 70,
    },
    {
      field: 'numero_pregunta',
      headerName: '#',
      width: 70,
    },
    {
      field: 'name',
      headerName: questionsQuestionString,
      width: 340,
    },
    {
      field: 'question_type',
      headerName: questionsQTypeString,
      width: 250,
    },
    {
      field: 'answer_type',
      headerName: questionsRTypeString,
      width: 250,
    },
  ];

  const reorderEndpoint = `${GlobalVariables.getURL()}reorderQuestion`;

  /**
   * Handles the change in order of a row using the provided parameters.
   * @param {Object} params - The parameters for row order change.
   * @param {number} params.oldIndex - The old index of the row.
   * @param {number} params.targetIndex - The target index for the row.
   */
  function handleRowOrderChange(params) {
    const oldIndex = params.oldIndex;
    const targetIndex = params.targetIndex;

    customAxios
      .patch(
        reorderEndpoint,
        {
          sectionId: selectedSection,
          targetIndex: targetIndex,
          oldIndex: oldIndex,
        },
        {
          headers: {
            Authorization: 'bearer ' + localStorage.getItem('token'),
          },
        },
      )
      .then((response) => {
        getToast({
          status: 'success',
          title: 'Sección actualizada exitosamente en la base de datos.',
        });
        getDirectoryData();
        getData(selectedSection);
      })
      .catch((error) => {
        getToast({
          status: 'error',
          title: 'Error al actualizar sección. Vuelve a intentarlo.',
        });
        console.error('Error: ', error);
      });
  }

  return (
    <>
      {selectedQuestion && anchorSecMenuRefs[selectedQuestion] && (
        <MoveToSectionMenu
          selectedQuestion={selectedQuestion}
          selectedSection={selectedSection}
          anchorSecMenu={
            selectedQuestion ? anchorSecMenuRefs[selectedQuestion] : null
          }
          openSecMenu={openSecMenu}
          handleSecMenuClose={handleSecMenuClose}
          getDirectoryData={getDirectoryData}
          getQuestionsData={getData}
        />
      )}

      <ModalQuestion
        show={modalQuestionShow}
        onHide={() => setModalQuestionShow(false)}
        getQuestionsData={getData}
        selectedSection={selectedSection}
        selectedQuestionnaire={selectedQuestionnaire}
        getDirectoryData={getDirectoryData}
      />

      <ModalMessage
        show={modalMessageShow}
        onHide={() => setModalMessageShow(false)}
        getQuestionsData={getData}
        selectedSection={selectedSection}
        selectedQuestionnaire={selectedQuestionnaire}
        getDirectoryData={getDirectoryData}
      />

      <ModalTitle
        show={modalSectionShow}
        onHide={() => setModalSectionShow(false)}
        getQuestionsData={getData}
        selectedSection={selectedSection}
        selectedQuestionnaire={selectedQuestionnaire}
        getDirectoryData={getDirectoryData}
      />

      <ModalQMultDelete
        show={modalQMultipleDeleteShow}
        onHide={() => setModalQMultipleDeleteShow(false)}
        getQuestionsData={getData}
        selectedSection={selectedSection}
        getDirectoryData={getDirectoryData}
      />

      <ModalQDelete
        show={modalQDeleteShow}
        onHide={() => setModalQDeleteShow(false)}
        getQuestionsData={getData}
        selectedSection={selectedSection}
        getDirectoryData={getDirectoryData}
      />

      <div className='questions-container'>
        <DataGridPro
          loading={isLoading}
          rows={configQData}
          columns={configQColumns.concat(actionColumn)}
          rowReordering
          onRowOrderChange={handleRowOrderChange}
          checkboxSelection
          localeText={locale.components.MuiDataGrid.defaultProps.localeText}
          onRowSelectionModelChange={(newRowSelectionModel) => {
            setRowSelectionModel(newRowSelectionModel);
            if (newRowSelectionModel.length >= 1) {
              setIsButtonDisabled(false);
            }
            if (newRowSelectionModel.length === 0) {
              setIsButtonDisabled(true);
            }
          }}
          rowSelectionModel={rowSelectionModel}
          slots={{
            noRowsOverlay: () => (
              <Stack height='100%' alignItems='center' justifyContent='center'>
                {noQuestionsString}
              </Stack>
            ),

            Row: GridRow,
          }}
        />
      </div>
    </>
  );
};
